import { render, staticRenderFns } from "./video-course.vue?vue&type=template&id=1c39adba&scoped=true&"
import script from "./video-course.vue?vue&type=script&lang=js&"
export * from "./video-course.vue?vue&type=script&lang=js&"
import style0 from "./video-course.vue?vue&type=style&index=0&lang=css&"
import style1 from "./video-course.vue?vue&type=style&index=1&id=1c39adba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39adba",
  null
  
)

export default component.exports